import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";

export const listarCategoriaContaBanco = createAsyncThunk("/ListarCategoriaContaBanco/ListarCategoriaContaBanco", async () => {
  try {
    const data = await api.get("/CategoriaContaBanco/ListarCategoriaContaBanco");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
